<div id="selector-container">
  <ul id="selector-list" data-testid="creditor">
    <li *ngFor="let supplier of supplierList"
      [ngClass]="{'selectedFournisseur': supplier.FournisseurId === selectedSupplierId}"
      (click)="onFournisseurSelected(supplier)">
      <div data-testid="creditor-element" [ngClass]="{'no-bill-to-pay': supplier.InvoiceToPayNumber === 0}">
        <span [attr.data-testid]="supplier.FournisseurId === selectedSupplierId ? 'creditor-selected' : null">
          {{ supplier.FournisseurNom }}
        </span>
      </div>
      <div *ngIf="supplier.InvoiceToPayNumber === 1" class="nb-factures"> {{ supplier.InvoiceToPayNumber }} facture à
        payer </div>
      <div *ngIf="supplier.InvoiceToPayNumber > 1" class="nb-factures"> {{ supplier.InvoiceToPayNumber }} factures à
        payer </div>
    </li>
  </ul>
</div>
